<template>
  <div>
    <draggable
      v-if="localValues.length"
      v-model="localValues"
      v-bind="dragOptions"
      handle=".handle"
      @start="drag=true"
      @end="drag=false"
      @change="$emit('input', localValues)">
      <transition-group
        type="transition"
        :name="transitionName"
      >
        <div
          class="drag-drop-option"
          v-for="(localValue, index) in localValues"
          :key="localValue.id"
        >
          <div class="handle">
            <DragAndDropIcon
              :color="iconColor"/>
            <span>{{ localValue.key }}</span>
          </div>
          <span
            class="close-icon"
            :title="'remove-'+localValue.value"
            @click="removeFromList(index)"
          >
            <ClearIcon/>
          </span>
        </div>
      </transition-group>
    </draggable>
    <div
      v-else
      class="empty-list"
    >
      {{ noOptionsMessage }}
    </div>
  </div>
</template>

<script>
import { DragAndDropIcon, ClearIcon } from '@mikmak/components';
import draggable from 'vuedraggable';

export default {
  props: {
    values: {
      type: Array,
      required: true,
      validator: val => val.every(el => el.key !== undefined
        && el.value !== undefined
        && el.id !== undefined,
      ),
    },
    noOptionsMessage: {
      type: String,
      default: 'There are not items to display',
    },
  },
  data() {
    return {
      localValues: this.values,
      iconColor: '#778699',
      drag: false,
    };
  },
  components: {
    DragAndDropIcon,
    ClearIcon,
    draggable,
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      };
    },
    transitionName() {
      return !this.drag ? 'flip-list' : null;
    },
  },
  methods: {
    removeFromList(index) {
      this.localValues.splice(index, 1);
      this.$emit('input', this.localValues);
    },
  },
  watch: {
    values() {
      this.localValues = this.values;
    },
  },
};
</script>
<style lang="scss" scoped>
.empty-list {
  font-weight: normal;
  font-size: 16px;
  line-height: 140%;
  text-align: center;
  color: #778699;
}

.drag-drop-option {
  height: 44px;
  width: 100%;
  background: #FFFFFF;
  border: 1px solid #C1CCD4;
  box-sizing: border-box;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 14px 10px;
  margin-bottom: 8px;

  .handle {
    cursor: grab;
    cursor: -moz-grab;
    cursor: -webkit-grab;
    width: 90%;
    display: flex;
    flex-direction: row;
    align-items: center;
      span {
        font-weight: normal;
        font-size: 16px;
        line-height: 100%;
        color: #223448;
        padding-left: 8px;
      }
  }

  .handle:active {
    cursor: grabbing;
    cursor: -moz-grabbing;
    cursor: -webkit-grabbing;
  }

  .close-icon {
    display: none;
  }
}

.drag-drop-option:hover {
  .close-icon {
    display: inherit;
    padding: auto;
    cursor: pointer;
  }
}

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #DADADA;
}
</style>
